import { Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './style';
import { ThreeDotsLoader } from 'plataforma-fundacao-componentes';

interface Props {
  inline?: boolean;
  estatico?: boolean;
  text?: string;
  backgroundTransparent?: boolean;
}

export default function Loading({
  inline,
  text,
  estatico,
  backgroundTransparent,
}: Props) {
  const classes = useStyles({ inline, estatico, backgroundTransparent });
  return (
    <div className={classes.root}>
      {/* <div className={classes.container}>
        <span className={[classes.dot, 'animation-wave'].join(' ')} />
        <span className={[classes.dot, 'animation-wave'].join(' ')} />
        <span className={[classes.dot, 'animation-wave'].join(' ')} />
      </div> */}
      <ThreeDotsLoader />
      {text && <Typography className={classes.text}>{text}</Typography>}
    </div>
  );
}
